import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { AutomationBuilderPage } from '../../../modules/automations/automation-builder'

const searchSchema = z.object({
  /** Template gallery key to prefill the builder with. */
  template: z.string().optional(),
})

export const Route = createFileRoute('/_authed/automations/new')({
  validateSearch: searchSchema,
  component: NewAutomationRoute,
})

function NewAutomationRoute() {
  const { template } = Route.useSearch()
  return <AutomationBuilderPage templateKey={template} />
}
